var map = {
	"./beer/Ayinger-Braeuweisse.webp": 3843,
	"./beer/ayinger-celebrator.webp": 7261,
	"./beer/ayinger-urweisse.webp": 5257,
	"./beer/catrin.webp": 2139,
	"./beer/surena.webp": 8386,
	"./groceries/Polar-Frost-BLACK-RASPBERRY.webp": 39,
	"./groceries/Polar-Frost-KIWI-STRWBRY.webp": 6347,
	"./groceries/Polar-Frost-LEMONADE.webp": 7480,
	"./groceries/Polar-Frost-ORANGE-MANGO.webp": 3308,
	"./groceries/goslings-ginger-diet.webp": 4523,
	"./groceries/goslings-ginger.webp": 6370,
	"./groceries/goslings-lemonpeach.webp": 5642,
	"./groceries/jarrito-mango.webp": 4579,
	"./groceries/jarrito-sandia.webp": 3275,
	"./groceries/jarrito-tamarindo.webp": 4434,
	"./groceries/jarrito-toronja.webp": 7876,
	"./groceries/jarritos-mandarina.webp": 5867,
	"./groceries/magneitc-lemon-guayaba.webp": 2224,
	"./groceries/magnetic-mango.webp": 1882,
	"./groceries/magnetic-peach.webp": 9393,
	"./groceries/maison-citrus.webp": 2897,
	"./groceries/maison-lemonjito.webp": 574,
	"./groceries/maison-lychee.webp": 8673,
	"./groceries/maison-perrier.webp": 2996,
	"./spirits/TequilaOcho.png": 7610,
	"./spirits/TequilaOcho1.png": 3081,
	"./spirits/TequilaOcho2.png": 8546,
	"./wine/azzulo.webp": 5636,
	"./wine/cava-albert.webp": 2007,
	"./wine/cava-brut.webp": 4908,
	"./wine/cava-demi.webp": 6804,
	"./wine/chateau-larteau.webp": 497,
	"./wine/chateau-nuit.webp": 637,
	"./wine/chateau-pierre.webp": 496,
	"./wine/chateau-senilhac.webp": 7372,
	"./wine/clos-air.webp": 2403,
	"./wine/clos-bel.webp": 2208,
	"./wine/dominio-reserva.webp": 9095,
	"./wine/dominio-tempranillo.webp": 6296,
	"./wine/fagus.webp": 599,
	"./wine/images__15_-removebg-preview.webp": 5063,
	"./wine/lolea-citrus.webp": 4121,
	"./wine/lolea-floral.webp": 8765,
	"./wine/lusco-albarino.webp": 9624,
	"./wine/ramon-tinto-envejecido.webp": 5932,
	"./wine/ramon-tinto.webp": 4731,
	"./wine/rioja-alberdi.webp": 9106,
	"./wine/rioja-ardanza.webp": 9200,
	"./wine/rioja-aster.webp": 7492,
	"./wine/rioja-gran-reserva.webp": 9501,
	"./wine/rioja-largar.webp": 4486,
	"./wine/senorio-blanco.webp": 870,
	"./wine/senorio-crianza.webp": 705,
	"./wine/senorio-rosado.webp": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6025;